import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  IDeltaHedgeOrderFormValues,
  IDeltaHedgeOrderTableReport,
  IDeltaHedgeOrderTablesSearchParam,
  IDeltaHedgeAggregationTablesSearchParam,
} from "../../../Interfaces/deltaHedgeOrder";
import {
  setDeltaHedgeEditFlag,
  setDeltaHedgeOrderFormValues,
  setDeltaHedgeOrderTableFlag,
} from "../../../Features/DeltaHedgeOrder/deltaHedgeOrderSlice";
import { store } from "../../../App/store";
import { getDeltaHedgeAggregatorTable } from "../../../Requests/deltaHedgeOrder";
import { DeltaHedgeAggregationAdditional } from "./AggregationAdditional";
import EditOrder from "../../../Pages/DeltaHedgeOrder/EditOrder";
import Modal from "../../../Components/Modal/Modal";
import { StepOrderSide } from "../../../Interfaces/stepInterfaces";

interface IProps {
  searchParam: IDeltaHedgeAggregationTablesSearchParam;
}

const DeltaHedgeAggregationTable = ({ searchParam }: IProps) => {
  const flag = useAppSelector(
    (store) => store.deltaHedgeOrder.orderTableFetchDataFlag,
  );
  const editFlag = useAppSelector((store) => store.deltaHedgeOrder.editFlag);
  const dispatch = useAppDispatch();

  const tableRowClickHandler = (row: IDeltaHedgeOrderTableReport) => {
    console.log(
      `id orderSide1 orderSide2 ${row.id} ${row.orderSide1} ${row.orderSide2}`,
    );
    dispatch(
      setDeltaHedgeOrderFormValues({
        ...(store.getState().deltaHedgeOrder?.addOrderFormValues ||
          ({} as IDeltaHedgeOrderFormValues)),
        instrumentId1: row.instrumentIds[0],
        optionOrderType1: row.optionOrderType1,
        orderSide1: row.orderSide1,
        instrumentId2: row.instrumentIds[1],
        optionOrderType2: row.optionOrderType2,
        orderSide2: row.orderSide2,
      }),
    );
  };

  return (
    <div className="overflow-auto order-table">
      {editFlag ? (
        <Modal title="ویرایش سفارش"
          UI={<EditOrder isConditionId={true} />}
          onClose={() => dispatch(setDeltaHedgeEditFlag(false))}
        />
      ) : (
        <></>
      )}
      <TableTemplate<
        IDeltaHedgeOrderTablesSearchParam,
        IDeltaHedgeOrderTableReport
      >
        refreshTableTime={10000}
        withSort
        getDataTable={getDeltaHedgeAggregatorTable}
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            withSelect
            reports={reports}
            onAction={() => {
              if (onAction) {
                onAction();
                dispatch(setDeltaHedgeOrderTableFlag(false));
              }
            }}
            onTableRowClick={tableRowClickHandler}
            sortingType={sortingType}
            setSortingType={setSortingType}
            refreshFlag={flag}
            AdditionalBody={DeltaHedgeAggregationAdditional}
            tableBoxClassName="max-h-[500px] overflow-auto"
          />
        )}
        searchParameters={searchParam}
        showPageSize
      />
    </div>
  );
};

export default DeltaHedgeAggregationTable;
